import { action } from 'typesafe-actions';
import ActionTypes from './constants';
import {DownloadType, InvalidationJobType, JobType, ReprocessingJobType} from "../../types/cart";

export const jobsSubmittedAction = (jobSubmitted: (JobType | InvalidationJobType | ReprocessingJobType)[]) => action(ActionTypes.JOBS_SUBMITTED, jobSubmitted);

export const downloadedProductsAction = (downloadsSubmitted: DownloadType[]) => action(ActionTypes.DOWNLOADED_PRODUCTS, downloadsSubmitted);
